import {cloneObject, uuid} from "../common/utils";
import {
  CommercialReleaseSummary,
  DeclarationStatus,
  Modality
} from '@portbase/bezoekschip-service-typescriptmodels';

export const releaseWithCrn: CommercialReleaseSummary =
  {
    "id": "4d02a9a47ec24b39a0b784a17ebb8b4a",
    "crn": "NLRTM24026524",
    "declarantShortName": "CHA1",
    "releaseData": {
      "equipmentNumber": "CXRU1282183",
      "terminalShortName": "RWG",
      "containerOperator": {
        "name": "Eimskip",
        "cargoDeclarantShortName": "EIMSKIPT",
        "smdgCode": "CA1"
      },
      "consignmentNumber": "EIMU2850144",
      "releaseDeadline": "2024-03-13T22:59:00Z",
      "releaseToParty": {"portbaseId": "VRV1", name: 'Van Rooijen Logistics B.V.', customerReference: 'VRV1'}
    },
    "releaseStatus": {
      "status": DeclarationStatus.DECLARED,
      "declarationDate": "2022-01-12T22:59:00Z",
      "rejectReasons": null,
      "cancelled": false
    }
  };


export const releaseWithoutCrn: CommercialReleaseSummary = {
  "id": "890ba8dcc0854aa2a9c215d6a94f901b",
  "crn": null,
  "declarantShortName": "CHA1",
  "releaseData": {
    "equipmentNumber": "CXRU1282184",
    "terminalShortName": "RWG",
    "containerOperator": {
      "name": "Eimskip",
      "cargoDeclarantShortName": "ONE",
      "smdgCode": "CA2"
    },
    "consignmentNumber": "EIMU2850145",
    "releaseDeadline": "2024-03-14T22:59:00Z",
    "releaseToParty": {"portbaseId": "VRV1", name: 'Rotra Transport B.V.', customerReference: 'VRV1'},
    "releaseModality": Modality.barge,
    "remarks": "call to extend"
  },
  "releaseStatus": {
    "status": DeclarationStatus.DECLARED,
    "declarationDate": "2022-01-14T22:59:00Z",
    "rejectReasons": null,
    "cancelled": false
  }
};


export const releaseWithoutDeclarationDate: CommercialReleaseSummary = {
  "id": "890ba8dcc0854aa2a9c215d6a94f901c",
  "crn": null,
  "declarantShortName": "CHA1",
  "releaseData": {
    "equipmentNumber": "CXRU1282185",
    "terminalShortName": "RWG",
    "containerOperator": {
      "name": "Eimskip",
      "cargoDeclarantShortName": "ONE",
      "smdgCode": "CA2"
    },
    "consignmentNumber": "EIMU2850146",
    "releaseDeadline": "2024-03-15T22:59:00Z",
    "releaseToParty": {"portbaseId": "VRV1", name: 'Cross-Ocean B.V.', customerReference: 'VRV1'},
    "releaseModality": Modality.rail,
    "remarks": "call to extend"
  },
  "releaseStatus": {
    "status": DeclarationStatus.DECLARED,
    "rejectReasons": null,
    "cancelled": false
  }
};

function accept(input: CommercialReleaseSummary) {
  let object = cloneDeclaration(input)
  object.releaseStatus.status = DeclarationStatus.ACCEPTED
  return object;
}

function reject(input: CommercialReleaseSummary) {
  let object = cloneDeclaration(input)
  object.releaseStatus.status = DeclarationStatus.REJECTED
  object.releaseStatus.rejectReasons = 'Some reason yes'
  return object;
}

function cancel(input: CommercialReleaseSummary) {
  let object = cloneDeclaration(input)
  object.releaseStatus.cancelled = true
  return object;
}

export const CommercialReleaseMock: CommercialReleaseSummary[] = [
  releaseWithCrn,
  releaseWithoutCrn,
  releaseWithoutDeclarationDate,
  accept(<any>releaseWithCrn),
  reject(<any>releaseWithCrn),
  cancel(<any>releaseWithCrn),
  cancel(accept(<any>releaseWithCrn)),
  cancel(reject(<any>releaseWithCrn))
]

function cloneDeclaration(input: CommercialReleaseSummary): CommercialReleaseSummary {
  const result = cloneObject(input);
  result.id = uuid();
  return result;
}
